import cx from "classnames"
import PropTypes from "prop-types"
import { Text } from "components/Text"
import { Price } from "components/Price"

export function FeesRow(props) {
  const { className, label, amount, currency, unit, ...rest } = props

  const classNames = cx(
    "flex flex-col lg:flex-row lg:items-center justify-between space-x-2",
    className,
  )

  return (
    <div className={classNames} {...rest}>
      <Text variant="body1">{label}</Text>
      <div className="space-x-1 flex flex-row items-center">
        <Text variant="body1">
          <Price amount={amount} currency={currency} />
        </Text>
        {unit ? <Text variant="caption">{unit}</Text> : null}
      </div>
    </div>
  )
}

FeesRow.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  unit: PropTypes.string,
}
